import React, { useState, useEffect } from 'react';
import './BollywoodFarmsModal.css';

const adventureActivities = [
  { icon: '🎯', text: 'Archery' },
  { icon: '🐴', text: 'Horse Riding' },
  { icon: '🎨', text: 'Paintball' },
  { icon: '🏏', text: 'Net Cricket' },
  { icon: '🏸', text: 'Multipurpose Court' },
  { icon: '🔥', text: 'Bonfire' },
];

const wellnessSpaces = [
  { icon: '🌿', text: 'Bonsai Plantation' },
  { icon: '🚶', text: 'Nature Trail' },
  { icon: '🌱', text: 'Planting Nursery' },
  { icon: '🦶', text: 'Reflexology Path' },
  { icon: '🛋️', text: 'Relaxing Deck' },
  { icon: '🌳', text: 'Relaxing Lawn & Garden' },
];

const socialAmenities = [
  { icon: '🏊', text: 'Swimming Pool' },
  { icon: '🏛️', text: 'Club House' },
  { icon: '🎉', text: 'Party Lawn' },
  { icon: '🍸', text: 'Party Decks' },
  { icon: '🌲', text: 'Focal Tree Plaza' },
  { icon: '☕', text: 'Café' },
];

const projectFeatures = [
  { num: '1', text: 'Pakka Construction Allowed' },
  { num: '2', text: 'Wide Internal Roads' },
  { num: '3', text: 'Organized Estate Planning' },
  { num: '4', text: 'Government Electricity Provision' },
  { num: '5', text: 'Planned Gated Development' },
  { num: '6', text: 'Premium Green Infrastructure' },
];

const idealFor = [
  { icon: '🏡', text: 'Signature Luxury Farm Villas' },
  { icon: '🏨', text: 'Resort-Style Farmhouses' },
  { icon: '🏊', text: 'Private Pools & Decks' },
  { icon: '🌺', text: 'Landscaped Gardens' },
  { icon: '👨‍👩‍👧‍👦', text: 'Multi-Generational Estates' },
  { icon: '🌾', text: 'Organic Farming Spaces' },
  { icon: '🎪', text: 'Outdoor Leisure Experience' },
  { icon: '✨', text: 'Weekend Retreat Culture' },
];

const connectivity = [
  { time: '8 MINS', place: 'Dankaur Railway Station' },
  { time: '15 MINS', place: 'Buddh International Circuit (F1)' },
  { time: '20 MINS', place: 'Noida International Airport (Jewar)' },
  { time: '20 MINS', place: 'YEIDA Film City & Pari Chowk' },
];

const airportHighlights = [
  '1,334 hectares (Phase 1) – India\'s largest greenfield airport',
  'Phase 1 investment: ₹11,200+ crore. Total: ₹29,561 crore',
  '12 million passengers per annum — expandable to 70+ MPPA',
  'Developed by Zurich Airport International AG',
  'Designed by Grimshaw, Nordic, Haptic & STUP',
  'World-class green airport — LEED Gold & Net Zero Carbon',
  'Integrated Cargo Terminal — 2.5 to 18 lakh metric tonnes',
  'Commercial flights officially began: 15 June 2026',
];

const daySchedule = [
  { time: '7:00 AM', icon: '🧘', activity: 'Morning yoga at Tree Grove Pathway surrounded by lush greenery and fresh farm air.' },
  { time: '8:00 AM', icon: '🚶', activity: 'Serene morning walk along the Nature Trail, breathing in the calm of the countryside.' },
  { time: '9:00 AM', icon: '🏊', activity: 'Swim in the luxurious Swimming Pool or relax on the Relaxing Deck with a cup of tea.' },
  { time: '11:00 AM', icon: '🐴', activity: 'Horse Riding through scenic trails or light play at the Net Cricket ground.' },
  { time: '1:00 PM', icon: '🥗', activity: 'Organic meal at the Club House Café, followed by relaxation on the Relaxing Lawn.' },
  { time: '5:00 PM', icon: '🎯', activity: 'Archery, Paintball, or Multipurpose Court — perfect for family fun.' },
  { time: '6:00 PM', icon: '🌅', activity: 'Evening tea at the Focal Tree Plaza, soaking in picturesque estate views.' },
  { time: '8:00 PM', icon: '🍽️', activity: 'Dinner at the Club House or host a gathering at Party Lawn / Party Decks.' },
  { time: '10:00 PM', icon: '🔥', activity: 'End your day around a warm Bonfire under the starry sky.' },
];

const tabs = ['Overview', 'Lifestyle', 'Airport & Growth', 'Film City', 'A Day Here', 'Contact'];

export default function BollywoodFarmsModal({ onClose }) {
  const [activeTab, setActiveTab] = useState('Overview');

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="baf-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="baf-modal">

        {/* ── HERO ── */}
        <div className="baf-hero">
          <img
            src="https://images.unsplash.com/photo-1625244724120-1fd1d34d00f6?w=1200&q=80"
            alt="Bollywood Aero City Farms"
            className="baf-hero-img"
          />
          <div className="baf-hero-overlay" />
          <button className="baf-close" onClick={onClose} aria-label="Close">
            <i className="fa fa-times" />
          </button>
          <div className="baf-hero-content">
            <div className="baf-badge">
              <span className="baf-badge-dot" />
              Premium Farm Estate · Near Jewar Airport
            </div>
            <div className="baf-brand">
              <span className="baf-brand-small">BOLLYWOOD</span>
              <h1>Aero City Farms</h1>
            </div>
            <p className="baf-tagline">
              Village Sarakpur, G.B. Nagar · Yamuna Expressway Region, India
            </p>
            <div className="baf-hero-tags">
              <span>✈️ Near Jewar Airport</span>
              <span>📐 1000 Sq. Yd. Estates</span>
              <span>💰 ₹20,000/Sq. Yd.</span>
              <span>🌿 Luxury Farm Living</span>
            </div>
            <div className="baf-price-strip">
              <div className="baf-price-item">
                <span>Plot Size</span>
                <strong>1000 Sq. Yd.</strong>
              </div>
              <div className="baf-price-divider" />
              <div className="baf-price-item">
                <span>Price</span>
                <strong>₹20,000 / Sq. Yd.</strong>
              </div>
              <div className="baf-price-divider" />
              <div className="baf-price-item">
                <span>Total Area</span>
                <strong>9000 Sq. Ft.</strong>
              </div>
              <div className="baf-price-divider" />
              <div className="baf-price-item">
                <span>Website</span>
                <strong>www.baf.in</strong>
              </div>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="baf-tabs">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`baf-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ── CONTENT ── */}
        <div className="baf-body">

          {/* OVERVIEW */}
          {activeTab === 'Overview' && (
            <div className="baf-section">
              <div className="baf-overview-grid">
                <div className="baf-overview-text">
                  <div className="baf-gold-tag">Delhi NCR's Next Big Growth Nucleus</div>
                  <h2>The Future of Luxury Farm Living</h2>
                  <p>
                    <strong>Bollywood AeroCity Farms</strong> is envisioned as a new-age luxury farm
                    estate destination where nature, infrastructure, and lifestyle come together
                    seamlessly.
                  </p>
                  <p>
                    Strategically located near <strong>Noida International Airport</strong> and
                    surrounded by future-defining developments — crafted for those who seek peaceful
                    green living, premium lifestyle experiences, and long-term asset creation.
                  </p>
                  <div className="baf-tagline-bold">
                    This is not just land ownership.<br />
                    <span>It is the creation of a Private Lifestyle Legacy.</span>
                  </div>
                  <div className="baf-highlights">
                    <div className="baf-hl-item">
                      <span className="baf-hl-num">1000</span>
                      <span className="baf-hl-label">Sq. Yd. Min.</span>
                    </div>
                    <div className="baf-hl-item">
                      <span className="baf-hl-num">₹20K</span>
                      <span className="baf-hl-label">Per Sq. Yd.</span>
                    </div>
                    <div className="baf-hl-item">
                      <span className="baf-hl-num">20</span>
                      <span className="baf-hl-label">Min. to Airport</span>
                    </div>
                    <div className="baf-hl-item">
                      <span className="baf-hl-num">200%</span>
                      <span className="baf-hl-label">ROI Expected</span>
                    </div>
                  </div>
                </div>

                <div className="baf-overview-right">
                  {/* Connectivity */}
                  <div className="baf-connectivity-card">
                    <h3>⚡ Prime Connectivity</h3>
                    {connectivity.map((c, i) => (
                      <div className="baf-conn-item" key={i}>
                        <div className="baf-conn-time">{c.time}</div>
                        <div className="baf-conn-place">{c.place}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Project Features */}
              <h3 className="baf-sub-heading">The Project Offers</h3>
              <div className="baf-features-grid">
                {projectFeatures.map((f, i) => (
                  <div className="baf-feature-card" key={i}>
                    <div className="baf-feature-num">{f.num}</div>
                    <span>{f.text}</span>
                  </div>
                ))}
              </div>

              {/* Ideal For */}
              <h3 className="baf-sub-heading">Ideal For — Not Plots. Private Estates.</h3>
              <div className="baf-ideal-grid">
                {idealFor.map((item, i) => (
                  <div className="baf-ideal-card" key={i}>
                    <span className="baf-ideal-icon">{item.icon}</span>
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* LIFESTYLE */}
          {activeTab === 'Lifestyle' && (
            <div className="baf-section">
              <h2>Luxury Rooted in Nature</h2>
              <p className="baf-section-sub">A thoughtfully rich, vibrant life — every single day</p>

              <div className="baf-amenity-cols">
                <div className="baf-amenity-group">
                  <div className="baf-amenity-group-title adventure">
                    🎯 Adventure Sports Activities
                  </div>
                  <div className="baf-amenity-list">
                    {adventureActivities.map((a, i) => (
                      <div className="baf-amenity-item" key={i}>
                        <span className="baf-amenity-emoji">{a.icon}</span>
                        <span>{a.text}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="baf-amenity-group">
                  <div className="baf-amenity-group-title wellness">
                    🌿 Nature Wellness Spaces
                  </div>
                  <div className="baf-amenity-list">
                    {wellnessSpaces.map((a, i) => (
                      <div className="baf-amenity-item" key={i}>
                        <span className="baf-amenity-emoji">{a.icon}</span>
                        <span>{a.text}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="baf-amenity-group">
                  <div className="baf-amenity-group-title social">
                    🏛️ Social Recreational Amenities
                  </div>
                  <div className="baf-amenity-list">
                    {socialAmenities.map((a, i) => (
                      <div className="baf-amenity-item" key={i}>
                        <span className="baf-amenity-emoji">{a.icon}</span>
                        <span>{a.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="baf-lifestyle-banner">
                <div className="baf-lifestyle-text">
                  <h3>Weekend Retreat Culture</h3>
                  <p>
                    Escape the city chaos every weekend. Experience sunrise yoga, evening bonfires,
                    horse rides, organic meals — all within your own private estate.
                    Bollywood AeroCity Farms is your permanent weekend address.
                  </p>
                </div>
                <div className="baf-lifestyle-stats">
                  <div><strong>18+</strong><span>Lifestyle Amenities</span></div>
                  <div><strong>3</strong><span>Activity Zones</span></div>
                  <div><strong>∞</strong><span>Memories Made</span></div>
                </div>
              </div>
            </div>
          )}

          {/* AIRPORT & GROWTH */}
          {activeTab === 'Airport & Growth' && (
            <div className="baf-section">
              <h2>Unstoppable Growth — Jewar International Airport</h2>
              <p className="baf-section-sub">India's Next Global Aviation & Investment Hub</p>

              <div className="baf-airport-grid">
                <div className="baf-airport-highlights">
                  {airportHighlights.map((h, i) => (
                    <div className="baf-airport-item" key={i}>
                      <span className="baf-airport-dot">◆</span>
                      <span>{h}</span>
                    </div>
                  ))}
                </div>

                <div className="baf-growth-card">
                  <h3>📈 Estimated Growth Trajectory</h3>
                  <div className="baf-growth-timeline">
                    <div className="baf-growth-year">
                      <div className="baf-year-dot early" />
                      <div>
                        <strong>2024–2025</strong>
                        <p>25–40% cumulative rise in property values</p>
                      </div>
                    </div>
                    <div className="baf-growth-year">
                      <div className="baf-year-dot mid" />
                      <div>
                        <strong>2025–2026</strong>
                        <p>Additional 28% rise + commercial flights begun</p>
                      </div>
                    </div>
                    <div className="baf-growth-year">
                      <div className="baf-year-dot high" />
                      <div>
                        <strong>2026–2028</strong>
                        <p>30–50% more growth due to industrialisation</p>
                      </div>
                    </div>
                    <div className="baf-growth-year">
                      <div className="baf-year-dot peak" />
                      <div>
                        <strong>By 2030</strong>
                        <p>Total 200–300% appreciation from 2025 levels</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Industry titans */}
              <h3 className="baf-sub-heading">Industry Titans Betting Big on This Region</h3>
              <div className="baf-titans-grid">
                <div className="baf-titan-card">
                  <div className="baf-titan-name">HAVELLS</div>
                  <p>~50 acres in YEIDA electronics cluster. Expected investment: ~₹800 crore.</p>
                </div>
                <div className="baf-titan-card">
                  <div className="baf-titan-name">FOXCONN</div>
                  <p>Semiconductor OSAT facility near Jewar. Investment: ~₹3,700 crore.</p>
                </div>
                <div className="baf-titan-card">
                  <div className="baf-titan-name">VIVO</div>
                  <p>Large land allotments (169 acres+). Thousands of crores in mobile manufacturing.</p>
                </div>
                <div className="baf-titan-card">
                  <div className="baf-titan-name">DIXON</div>
                  <p>Letter of Intent (LOI) for YEIDA region electronics manufacturing.</p>
                </div>
              </div>
            </div>
          )}

          {/* FILM CITY */}
          {activeTab === 'Film City' && (
            <div className="baf-section">
              <h2>Noida International Film City</h2>
              <p className="baf-section-sub">North India's largest integrated Film City — just 4 km from Jewar Airport</p>

              <div className="baf-filmcity-banner">
                <div className="baf-filmcity-stat">
                  <strong>1,000</strong><span>Acres Total</span>
                </div>
                <div className="baf-filmcity-stat">
                  <strong>₹65,000 Cr</strong><span>Total Investment</span>
                </div>
                <div className="baf-filmcity-stat">
                  <strong>50,000+</strong><span>Direct Jobs</span>
                </div>
                <div className="baf-filmcity-stat">
                  <strong>4 Km</strong><span>From Airport</span>
                </div>
              </div>

              <div className="baf-filmcity-points">
                <div className="baf-fc-point">
                  <div className="baf-fc-num">1</div>
                  <div>
                    <h4>Complete Film Ecosystem</h4>
                    <p>10 sound-proof stages, massive backlots, underwater tank, VFX labs & post-production facilities.</p>
                  </div>
                </div>
                <div className="baf-fc-point">
                  <div className="baf-fc-num">2</div>
                  <div>
                    <h4>Unmatched Strategic Location</h4>
                    <p>Just 4 km from Jewar Airport along Yamuna Expressway — seamless global connectivity for international productions.</p>
                  </div>
                </div>
                <div className="baf-fc-point">
                  <div className="baf-fc-num">3</div>
                  <div>
                    <h4>North India's Biggest Film Hub</h4>
                    <p>Film Institute, Bollywood Walk of Fame, entertainment zones attracting Bollywood, Hollywood & regional cinema.</p>
                  </div>
                </div>
                <div className="baf-fc-point">
                  <div className="baf-fc-num">4</div>
                  <div>
                    <h4>Powerful Economic Catalyst</h4>
                    <p>Massive growth in YEIDA region alongside electronics, logistics & aviation — 7 lakh+ livelihoods impacted.</p>
                  </div>
                </div>
                <div className="baf-fc-point">
                  <div className="baf-fc-num">5</div>
                  <div>
                    <h4>World-Class & Future-Ready</h4>
                    <p>LED walls, virtual production, GRIHA 4-Star / IGBC Gold sustainability standards, luxury hospitality.</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* A DAY HERE */}
          {activeTab === 'A Day Here' && (
            <div className="baf-section">
              <h2>A Day at Bollywood Aero City Farms</h2>
              <p className="baf-section-sub">Days Like These — your perfect 24 hours in paradise</p>

              <div className="baf-day-timeline">
                {daySchedule.map((d, i) => (
                  <div className="baf-day-item" key={i}>
                    <div className="baf-day-time">
                      <span>{d.time}</span>
                    </div>
                    <div className="baf-day-connector">
                      <div className="baf-day-dot">{d.icon}</div>
                      {i < daySchedule.length - 1 && <div className="baf-day-line" />}
                    </div>
                    <div className="baf-day-text">{d.activity}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* CONTACT */}
          {activeTab === 'Contact' && (
            <div className="baf-section">
              <h2>Own Your Farm Estate</h2>
              <p className="baf-section-sub">A rare opportunity — don't miss Delhi NCR's fastest appreciating corridor</p>

              <div className="baf-contact-grid">
                <div className="baf-contact-card">
                  <div className="baf-contact-icon">📍</div>
                  <div>
                    <h4>Location</h4>
                    <p>Village Sarakpur, G.B. Nagar,<br />Near Dankaur Railway Station,<br />Yamuna Expressway Region, India</p>
                  </div>
                </div>
                <div className="baf-contact-card">
                  <div className="baf-contact-icon">🌐</div>
                  <div>
                    <h4>Website</h4>
                    <p>www.baf.in</p>
                  </div>
                </div>
                <div className="baf-contact-card">
                  <div className="baf-contact-icon">💰</div>
                  <div>
                    <h4>Pricing</h4>
                    <p>₹20,000 per Sq. Yd.<br />Minimum 1000 Sq. Yd. (All-Inclusive)</p>
                  </div>
                </div>
                <div className="baf-contact-card">
                  <div className="baf-contact-icon">📞</div>
                  <div>
                    <h4>Enquire</h4>
                    <p>+91 94149-53399<br />info@paradisegroupncr.com</p>
                  </div>
                </div>
              </div>

              <button className="baf-cta-btn">
                ✈️ Book a Site Visit at Bollywood Aero City Farms
              </button>

              <div className="baf-disclaimer">
                <strong>Disclaimer:</strong> This brochure is for information purposes only and does not
                constitute an offer or invitation for sale. All details, images, and specifications are
                conceptual and subject to change. Please refer to the official agreement and concerned
                authorities before making any booking or investment. *T&C Apply.
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
